import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { routes } from './app/app-routing.module';
import { provideToastr } from 'ngx-toastr';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { provideServiceWorker } from '@angular/service-worker';
import { isDevMode } from '@angular/core';
import { provideAuth0 } from '@auth0/auth0-angular';
import { environment } from './environments/environment';
import { provideTranslate } from './app/providers/translate.provider';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthHttpInterceptor } from '@auth0/auth0-angular';
import { LoadingInterceptor } from './app/interceptors/loading.interceptor';
import { DATE_FORMATS } from 'src/environments/environment';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { customTooltipDefaults } from './app/config/tooltip.config';
import { registerLocaleData } from '@angular/common';
import localeEN from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localePT from '@angular/common/locales/pt';

// Register locale data for internationalization
registerLocaleData(localePT);
registerLocaleData(localeEN);
registerLocaleData(localeEs);

const translateProviders = provideTranslate();

bootstrapApplication(AppComponent, {
  providers: [
    // HTTP interceptors
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
    // Date formats and adapters
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en' },
    { provide: MomentDateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    // Theme and gesture configuration
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: customTooltipDefaults,
    },
    // Core providers
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter(routes),
    provideToastr(),
    provideEnvironmentNgxMask(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideAuth0({
      domain: environment.auth0Domain,
      clientId: environment.auth0ID,
      authorizationParams: {
        domain: environment.auth0Domain,
        clientID: environment.auth0ID,
        redirect_uri: window.location.origin,
        audience: environment.auth0Audience,
        currentRoute: window.location.href,
        language: localStorage.getItem('defaultLang'),
        ui_locales: navigator.language || 'en',
        appState: {
          target: '/overview',
        },
      },
      httpInterceptor: {
        allowedList: [
          {
            uri: environment.api + '*',
            allowAnonymous: true,
            tokenOptions: {
              authorizationParams: {
                audience: environment.auth0Audience,
              },
            },
          },
        ],
      },
    }),
    ...translateProviders,
  ],
}).catch((err) => console.error(err));

declare global {
  interface Window {
    ethereum: any;
  }
}
